import axios from "axios";

export default {
  loading(context, value) {
    context.commit("loading", value);
  },
  setConfigs(context, value) {
    context.commit("setConfigs", value);
  },
  setPusher(context, value) {
    context.commit("setPusher", value);
  },
  setBackdrop(context, value) {
    context.commit("setBackdrop", value);
  },
  openMenuNav(context, value) {
    context.commit("setBackdrop", value);
    context.commit("openMenuNav", value);
    let body = document.querySelector("body");
    if (value) {
      body.classList.add("modal-open");
    } else {
      body.classList.remove("modal-open");
    }
  },
  setError(context, err) {
    context.dispatch("loading", false);

    let message = "";
    let url;

    if ("response" in err) {
      if (err.response.status == 429) {
        message = err.response.statusText;
      } else if (err.response) {
        message = err.response.data.message;
      }

      if ("data" in err.response && "url" in err.response.data) {
        url = err.response.data.url;
      }
    } else if ("request" in err.request) {
      message = err.message;
    } else {
      message =
        "Ops, aconteceu algum erro desconhecido. Tente novamente em alguns minutos.";
    }

    if (message == "") {
      context.commit("setError", {
        open: false,
        message: message,
        url: url,
        key: new Date().getTime(),
      });
    } else {
      context.commit("setError", {
        open: true,
        message: message,
        url: url,
        key: new Date().getTime(),
      });
    }
  },
  setAlert(context, message) {
    let payload = {};
    payload.key = new Date().getTime();
    payload.message = message;
    payload.open = true;

    context.commit("setAlert", payload);
  },
  setModalAlert(context, payload) {
    payload.key = new Date().getTime();

    context.commit("setModalAlert", payload);
  },
  async login(context, loginData) {
    try {
      const response = await axios.post('api/v1/user/login', loginData);
      if (response.data.success) {
        const token = response.data.data.user.token;
        const user = response.data.data.user.data;

        context.commit('setUser', user);
        context.commit('setToken', token);

        localStorage.setItem('token', token);
      } else {
        return response.data;
      }
      return response.data;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },

  async setLogout({ commit }) {
    commit('setUser', null);
    commit('setToken', null);
    localStorage.removeItem('token');
  },

  setUserLoggedIn(context, { user }) {
    context.commit('setUser', user);
  },

  async getUserData(context, token) {
    try {
      const response = await axios.post('api/v1/user/user-data', { token: token });
      if (response.data.success) {
        context.commit('setUser', response.data.data);
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'Ops...',
          text: 'No se pudo obtener los datos del usuario. Por favor, inicie sesión nuevamente.',
        });
        this.$router.push('/');
      }
      return response.data.data;
    } catch (error) {
      console.error('Get user data failed:', error);
      this.$swal.fire({
        icon: 'error',
        title: 'Ops...',
        text: 'No se pudo obtener los datos del usuario. Por favor, inicie sesión nuevamente.',
      });
      this.$router.push('/');
      return null;
    }
  },
  changeData({ commit }) {
    commit('setChangePassword', false);
    commit('setChangeDataUser', true);
    commit('setChangePhone', false);
    commit('setChangeRgpd', false);
    commit('setPortability', false);
    commit('setForget', false);
  },
  changePhone({ commit }) {
    commit('setChangePassword', false);
    commit('setChangeDataUser', false);
    commit('setChangePhone', true);
    commit('setChangeRgpd', false);
    commit('setPortability', false);
    commit('setForget', false);
  },
  changePassword({ commit }) {
    commit('setChangePassword', true);
    commit('setChangeDataUser', false);
    commit('setChangePhone', false);
    commit('setChangeRgpd', false);
    commit('setPortability', false);
    commit('setForget', false);
  },
  changeRGPD({ commit }) {
    commit('setChangeRgpd', true);
    commit('setChangePassword', false);
    commit('setChangeDataUser', false);
    commit('setChangePhone', false);
    commit('setPortability', false);
    commit('setForget', false);
  },
  portability({ commit }) {
    commit('setPortability', true);
    commit('setChangeRgpd', false);
    commit('setChangePassword', false);
    commit('setChangeDataUser', false);
    commit('setChangePhone', false);
    commit('setForget', false);
  },
  forget({ commit }) {
    commit('setForget', true);
    commit('setPortability', false);
    commit('setChangeRgpd', false);
    commit('setChangePassword', false);
    commit('setChangeDataUser', false);
    commit('setChangePhone', false);
  },
  toggleCarteira({ commit }) {
    commit('setCarteiraActive', true);
    commit('setTransactionActive', false);
    commit('setAccountActive', false);
    commit('setChangeDataUser', false);
    commit('setChangePhone', false);
    commit('setChangePassword', false);
    commit('setChangeRgpd', false);
    commit('setPortability', false);
    commit('setForget', false);
  },
  toggleTransaction({ commit }) {
    commit('setTransactionActive', true);
    commit('setCarteiraActive', false);
    commit('setAccountActive', false);
    commit('setChangeDataUser', false);
    commit('setChangePhone', false);
    commit('setChangePassword', false);
    commit('setChangeRgpd', false);
    commit('setPortability', false);
    commit('setForget', false);
  },
  toggleAccount({ commit }) {
    commit('setAccountActive', true);
    commit('setCarteiraActive', false);
    commit('setTransactionActive', false);
    commit('setChangeDataUser', false);
    commit('setChangePhone', false);
    commit('setChangePassword', false);
    commit('setChangeRgpd', false);
    commit('setPortability', false);
    commit('setForget', false);
  },
};
